document.addEventListener("click", (e) => {
  const btn = e.target.closest("[bss-b2b-btn-quickview]");
  if (!btn) return;
    setTimeout(() => {
        document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`)) 
    }, 500);
});


if(window.location.pathname.endsWith("/cart")) {
  const container = document.querySelector("[bss-b2b-final-line-price] .price")
  setTimeout(() => {
    if(container)
      BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
  }, 2000);
}

const selector = ".modal--cart.modal.modal--right.modal--dark";
let waitingForOpen = true;

const observer = new MutationObserver(() => {
  const el = document.querySelector(selector);
  if (!el) return;

  const isHidden = el.getAttribute("aria-hidden") === "true";

  if (!isHidden && waitingForOpen) {
    waitingForOpen = false;
    BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
  }

  if (isHidden && !waitingForOpen) {
    waitingForOpen = true;
  }
});

observer.observe(document.body, {
  subtree: true,
  attributes: true,
  attributeFilter: ["aria-hidden"]
});


            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
            }, 600)

